import { msg } from "@lingui/macro";
import type { MessageDescriptor } from "@lingui/core";

import type { ContractType } from "../types";

const taskHintMessages: Record<ContractType, MessageDescriptor> = {
  log_analysis: msg`Помечай только подозрительные события. Лишние и пропущенные пометки снижают оценку.`,
  network_map: msg`Отметь рискованные узлы и подбери к ним меры. Лишние пометки снижают результат.`,
  phishing: msg`Отмечай только фишинговые письма. Лишние и пропущенные пометки снижают оценку.`,
  report_builder: msg`Выбери самые значимые рекомендации и уложись в бюджет клиента.`,
};

export function taskHintText(contractType: ContractType): MessageDescriptor {
  return taskHintMessages[contractType];
}

const taskDescriptionMessages: Record<ContractType, MessageDescriptor> = {
  log_analysis: msg`Просмотри журнал входов и отметь подозрительные события.`,
  network_map: msg`Изучи карту сети: отметь рискованные узлы и подбери меры.`,
  phishing: msg`Просмотри входящие клиента и отметь фишинговые письма.`,
  report_builder: msg`Собери отчёт: выбери находки и рекомендации в рамках бюджета.`,
};

export function taskDescriptionText(contractType: ContractType): MessageDescriptor {
  return taskDescriptionMessages[contractType];
}
